import classNames from 'classnames';
import React from 'react';

import Slides from 'common/components/RewindModal/Slides';

import styles from '../styles.module.scss';
import BottomActions from './component/BottomActions';

type TopGlobalMoviesIntroProps = {
  onNext: () => void;
  isLastStep: boolean;
};

const TopGlobalMoviesIntro: React.FC<TopGlobalMoviesIntroProps> = ({
  onNext,
  isLastStep
}) => {
  const title = 'Top Films';
  const subtitle =
    "Pas besoin de jury : l'académie des cinéphiles AlloCiné a parlé";

  return (
    <Slides>
      <div className={classNames(styles.contentLayout, styles.startLayout)}>
        <h2 className={styles.slideTitle}>{title}</h2>
        <h3 className={styles.slideText}>{subtitle}</h3>
      </div>
      <BottomActions
        showShare={false}
        showNext={!isLastStep}
        onNextClick={onNext}
      />
    </Slides>
  );
};

export default TopGlobalMoviesIntro;
